import { custom_event, deep_clone } from "@src/utilities"


function get_all_values_for_key(obj, key) {
  let values = [];
  for (let prop in obj) {
    if (prop === key) {
      values.push(obj[prop]);
    } else if (typeof obj[prop] === 'object') {
      values = values.concat(get_all_values_for_key(obj[prop], key));
    }
  }
  return values;
}

function parse_soluzioni(soluzioni, departure_airports) {
  const tuttiGliAeroporti = get_all_values_for_key(departure_airports, 'iata_code')
  const solutionMap = {}

  soluzioni.forEach(solution => {
    solution.flights.forEach(flight => {
      if (tuttiGliAeroporti.includes(flight.aptPart)) {
        const solutionKey = flight.descrAptPart
        if (!solutionMap[solutionKey]) {
          solutionMap[solutionKey] = {
            label: solutionKey,
            aptPart: flight.aptPart,
            soluzioni: []
          }
        }
        solutionMap[solutionKey].soluzioni.push(solution)
      }
    })
  })

  return Object.values(solutionMap)
}

function parse_scheda(scheda, tutteLeCamere, departure_date) {

  // CARATTERISTICHE PRODOTTO

  const carat_prod = {
    categoryMap : {},
    known_keys : ['i_piu_amati', 'panoramica_hotel', 'lista_servizi', 'panoramica_tour', 'perche_scegliere_questo_tour'],
    known : {},
    unknown : {}
  }

  scheda.caratteristiche_prodotto.forEach(item => {

    if (!Array.isArray(item.categorie) || item.categorie.length === 0) {
      item.categorie = ['not_categorize']
    }

    item.categorie.forEach(category => {

      const categoryKey =
          category.toLowerCase().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '').replace(/ /g, "_");

      if (!carat_prod.categoryMap[categoryKey]) carat_prod.categoryMap[categoryKey] = [];

      carat_prod.categoryMap[categoryKey].push(item);
    });
  })

  Object.keys(carat_prod.categoryMap).forEach(item => {
    const certified_item = carat_prod.known_keys.includes(item);
    const cat_obj = certified_item ? carat_prod.known : carat_prod.unknown;

    cat_obj[item] = carat_prod.categoryMap[item];
  })

  scheda.caratteristiche_prodotto = {
    'known' : carat_prod.known,
    'unknown': carat_prod.unknown
  }


  // INFORMAZIONI

  const info_prod = {
    infoMap : {},
    known_keys : tutteLeCamere,
    known : {},
    unknown : {},
    faq_struttura : []
  }

  scheda.informazioni.forEach(info => {
    info.cod === 'FAQG' ? info.testo_informazione.forEach(faq => {
      if(faq.titolo !== '') info_prod.faq_struttura.push(faq)
    }) : info_prod.infoMap[info.cod] = info
  })

  Object.keys(info_prod.infoMap).forEach(item => {
    const certified_item = info_prod.known_keys.includes(item);
    const cat_obj = certified_item ? info_prod.known : info_prod.unknown;

    cat_obj[item] = info_prod.infoMap[item];
  })

  scheda.informazioni = {
    'known' : info_prod.known,
    'unknown': info_prod.unknown
  }
  scheda.faq_struttura = info_prod.faq_struttura


  // PROGRAMMAZIONE TOUR

  if(departure_date) {

    scheda.programmi = scheda.programmi.filter(element => {

      if (element.data_validita_da === "" && element.data_validita_a === "") return true

      const start_date = element.data_validita_da;
      const end_date = element.data_validita_a;

      return departure_date.localeCompare(start_date) > 0 && departure_date.localeCompare(end_date) < 0;
    });
  }


  return scheda
}

function sort_by_selected_airports(product_detail, departure_airports) {
  const selected_airports = departure_airports.filter(a => a.selected).map(x => x.iata_code)

  product_detail.forEach(product => {
    product.soluzioni_parsed.sort((a, b) => {
      const indexA = selected_airports.indexOf(a.aptPart)
      const indexB = selected_airports.indexOf(b.aptPart)
      if (indexA === -1 && indexB === -1) return 0
      if (indexA === -1) return 1
      if (indexB === -1) return -1
      return indexA - indexB
    })
  })
}

function build_supplement(product_detail) {
  return product_detail.map((product) => {
    return product.soluzioni_parsed.map((soluzione_parsed) => {
      return soluzione_parsed.soluzioni.map((soluzione) => {
        return soluzione.hotels.map((hotel) => {
          return hotel.roomCombination.map((roomcomb) => {
            return roomcomb.rooms.map((room) => {
              let suppl = room.trattamenti[0]
              return {
                idGruppoTrattamento: suppl.idGruppoTrattamento,
                totAmount: suppl.totAmount,
                descrizioneOfferta: suppl.descrizioneOfferta
              }
            })
          })
        })
      })
    })
  })
}

function build_statics(success, departure_date) {
  const tutteLeCamere = get_all_values_for_key(success.data.data.prodotti, 'tipoCam')
  const model_statics = {}
  Object.keys(success.data.data.statics).forEach(key_pid => {
    success.data.data.statics[key_pid].schedaProdotto = parse_scheda(
      deep_clone(success.data.data.statics[key_pid].schedaProdotto),
      tutteLeCamere,
      departure_date
    )
    model_statics[key_pid] = success.data.data.statics[key_pid]
  })
  return model_statics
}


/**
 * Processa la response API /price per il flusso flight-and-stay.
 * Parsa prodotti, emette analytics, ordina soluzioni, costruisce supplement e statics.
 *
 * @param {Object} success - response Axios
 * @param {Object} options
 * @param {Array}  options.departure_airports - aeroporti di partenza dallo store
 * @param {String} options.departure_date - data di partenza dallo store
 * @returns {{ product_detail: Array, supplement: Array, statics_detail: Object }}
 */
export function process_response(success, { departure_airports, departure_date }) {
  const prodotti = success.data.data.prodotti

  const product_detail = prodotti.map(product => {
    custom_event(
      'detail',
      product.baseProdotto.descrizProdotto + ' ' +
      product.baseProdotto.nomeHotel, product.baseProdotto.pid, 'product'
    )
    product.soluzioni_parsed = parse_soluzioni(product.soluzioni, departure_airports)
    delete product.soluzioni
    return product
  })

  sort_by_selected_airports(product_detail, departure_airports)
  const supplement = build_supplement(product_detail)
  const statics_detail = build_statics(success, departure_date)

  return { product_detail, supplement, statics_detail }
}
